// extracted by mini-css-extract-plugin
module.exports = {"base":"Admin_base__2bqb9","card":"Admin_card__3DbB2","title":"Admin_title__2vhX_","records":"Admin_records__1aciu","count":"Admin_count__cCdKR"};